module.exports = __webpack_public_path__ + "img/HU.7ed41546.jpg";